export default {
  formId: 'createTipoCotizacion', //'createTipoCotizacion',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre*',
      requiredErrorMsg: 'El nombre es requerido.',
    },
    description: {
      name: 'description',
      label: 'Descripcion*',
      requiredErrorMsg: 'La descripcion es requerida.',
    },
  },
};
